import React, { useEffect, useId, useState } from 'react'
// import clsx from 'clsx'
import { H4, Icon } from '@maggioli-design-system/react'

const AccordionItem = ({ className = "", opened = false, onToggle = null, ...restProps }) => {

    const [ isOpened, toggle ] = useState(opened)

    const id = useId()
    const contentID = `accordion-content-${id}`
    const actionID = `accordion-action-${id}`

    useEffect(() => {
        toggle(opened)
    }, [opened])

    const onClickToggle = () => {
        toggle(!isOpened)
        typeof onToggle === "function" && onToggle(!isOpened)
    }

    return <div className={className + ' accordion-item grid gap-0 py-4'}>
        {/* L'intestazione è un pulsante: annuncia lo stato aperto/chiuso ed è raggiungibile da tastiera */}
        <button
            aria-controls={contentID}
            aria-expanded={isOpened}
            className="accordion-item__action flex gap-4 items-center justify-between w-full text-left bg-transparent border-0 p-0 cursor-pointer"
            id={actionID}
            onClick={onClickToggle}
            type="button">
            <H4 className="flex-grow">{ restProps.title }</H4>
            <Icon aria-hidden="true" className={`flex-shrink-0 transition-transform rotate-0 duration-300 ease-in-out ' ${isOpened && 'rotate-180'})`} name="form-dropdown" />
        </button>
        <div aria-labelledby={actionID} className={`grid accordion-item__content ' ${isOpened ? 'accordion-item__content--opened pt-4' : 'pt-0'}`} id={contentID} role="region">
            <div className="overflow-hidden">
                { restProps.children }
            </div>
        </div>
    </div>
}

const Accordion = ({ className = "", ...restProps }) =>
    <div className={className + ' grid gap-0'}>
        { restProps.children }
    </div>


export {
    Accordion,
    AccordionItem,
}
